import React from "react";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import styles from "./page-loader.module.scss"

interface PageLoaderProps {
    tip?: React.ReactNode
}

export const PageLoader: React.FC<PageLoaderProps> = ({tip}) => {

    return (
        <div className="container">
            <div className={styles.loader}>
                <Spin indicator={<LoadingOutlined style={{fontSize: 50}} spin/>}/>
                {tip ? (
                    <div className={styles.tip}>
                        {tip}
                    </div>
                ) : null}
            </div>
        </div>
    )
}
